import moment from "moment";

export const daysOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

export const addSchedulePayloadBuilder = (payload, organizationId) => {
    const { startTime, endTime, name, channels, payoutRate, pricingRate } = payload;
    const format = "MM/DD/YYYY HH:mm:ss";

    const formatDays = daysOfWeek
        .filter((day) =>  payload[day])
        .map((day) => day.toLowerCase())
    const _dataSourceHandles = channels.map((channel) => channel.id)

    return {
        name,
        payoutRate,
        pricingRate,
        days: {selectedDays: formatDays},
        startTime: moment(startTime).format(format),
        endTime: moment(endTime).format(format),
        organization: organizationId,
        dataSourceHandles: _dataSourceHandles
    };
}

export const editSchedulePayloadBuilder = (payload) => {
    const { startTime, endTime, name, payoutRate, pricingRate, isActive } = payload;
    const format = "MM/DD/YYYY HH:mm:ss";

    const formatDays = daysOfWeek
        .filter((day) =>  payload[day])
        .map((day) => day.toLowerCase())

    return {
        name,
        payoutRate,
        pricingRate,
        isActive,
        days: {selectedDays: formatDays},
        startTime: moment.utc(startTime).format(format),
        endTime: moment.utc(endTime).format(format),
    };
}

